<template>
  <div class="w-full bg-white dark:bg-slate-700 shadow-base p-6 rounded-md">
    <table
      class="animate-pulse w-full border-separate border-spacing-4 table-fixed"
    >
      <thead>
        <tr>
          <th scope="col" v-for="(col, index) in columns" :key="index">
            <div class="h-5 bg-[#C4C4C4] dark:bg-slate-500 rounded"></div>
          </th>
        </tr>
      </thead>
      <tbody class="table-group-divider">
        <tr v-for="(item, i) in items" :key="i">
          <td v-for="(col, index) in columns" :key="index">
            <div class="h-3 bg-[#C4C4C4] dark:bg-slate-500 rounded"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    count: {
      type: Number,
      default: 6,
    },
    cols: {
      type: Number,
      default: 5,
    },
  },

  computed: {
    items() {
      return Array.from({ length: this.count });
    },
    columns() {
      return Array.from({ length: this.cols });
    },
  },
};
</script>
<style lang=""></style>
